module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAAAzUlEQVQ4jWM8wsBwiIGBgYmBduADCwMDgxUDAwMzDS35xERjX4DAX5AF/2hsyR+cvuCNiGAw//KFQefiRRRx6///cWIOJyesZrFgExTMzmbQmjKF4c/Xrxhyr3buZGCXlGS4oq9PtFewWvJ+6lSGW0JCDBzy8gz8pqZEG4YL4Ayu183NFBsOA2SlLH49PYx4keztxakea3ARAh8vXSIpTmidR4aZJXjj5HFKCsNjKlgCKoX/0LiAfA0KLkYaWgACrKDgek3DVMbIwMDwFgAn+z+ltQRh7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/1F.png
// module id = IawL
// module chunks = 0